<template>
  <div class="mian_view">
    <h2>个体练习情况</h2>
    <!-- 查询 -->
    <div class="waitingcom_title">
      <el-form
        :model="formLabelAlign"
        ref="formLabelAlign"
        label-width="70px"
        :label-position="labelPosition"
      >
        <el-form-item label="科室：">
          <el-select v-model="formLabelAlign.department" @change="queryChange">
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in departmentArr"
              :key="item.DepartmentID"
              :label="item.DepartmentName"
              :value="item.DepartmentID"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="职称：">
          <el-select v-model="formLabelAlign.title" @change="handleQuery">
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in titleArr"
              :key="item.PTitle"
              :label="item.PTitle"
              :value="item.PTitle"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="时间：">
          <el-date-picker
            v-model="formLabelAlign.examTime"
            @change="handleQuery"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>

      <!-- 搜索按钮 -->
      <div class="query_btn">
        <div class="search_left">
          <el-input
            v-model="formLabelAlign.practiceName"
            icon="el-icon-search"
            placeholder="根据考生名称或账号进行搜索"
          ></el-input>
          <i class="iconfont icon-sousuo"></i>
        </div>
        <el-button
          @click="handleQuery"
          type="primary"
          icon="el-icon-search"
          class="searchbtn"
          >搜索</el-button
        >
        <el-button
          @click="resetForm('formLabelAlign')"
          icon="el-icon-refresh"
          class="searchbtn sonbtn"
          >重置</el-button
        >
        <el-button
          @click="exportExcel"
          icon="el-icon-download"
          class="searchbtn sonbtn"
          >导出</el-button
        >
      </div>
    </div>
    <!-- 信息 -->
    <div class="info_view">
      <p>科室：{{ departmentNum() }}</p>
      <p>科室人数：{{ infoObj.allpeople }}</p>
      <p>已练习人数：{{ infoObj.joinPeople }}</p>
      <p>参与率：{{ infoObj.participate }}%</p>
      <p>正确率：{{ infoObj.correct }}%</p>
    </div>
    <!-- 表格 -->
    <div class="mian_table" v-loading="loading">
      <el-table
        :data="getData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          'background-color': '#8FCBFF',
          color: '#333333',
          height: '60px',
        }"
      >
        <el-table-column label="序号" type="index" width="60" align="center"
          ><template slot-scope="scope">
            <span>{{ (pageIndex - 1) * eachPageNum + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in formColumns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          height="150"
          label-height="50"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
      </el-table>
    </div>
    <div class="foot_box">
      <div class="foot_pagetions">
        <p>共有{{ total }}条记录，当前第{{ pageIndex }}/{{ pagesun }}页</p>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageIndex"
          :page-size="eachPageNum"
          :page-sizes="pagesizesarr"
          layout="prev, pager, next,sizes, jumper"
          :total="total"
          class="pagination"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import loginvuex from "@/store/index";
import { exerciseState } from "@/state/practiceModel";
import $examApi from "@/api/examApi.js";
import getstudentlist from "@/api/questionbank";
export default {
  data() {
    return {
      labelPosition: "right",
      formLabelAlign: {
        practiceName: "", // 练习名称
        department: "", // 科室
        title: "", // 职称
        examTime: "", // 时间
        createBeginTime: "",
        createEndTime: "",
      },
      formColumns: [],
      getDataCondition: {
        practiceName: "", // 练习名称
      },
      getData: [], // 表格数据
      pageIndex: 1, // 起始页
      eachPageNum: 10, // 一页多少条数据
      total: 100,
      loading: false,
      pagesun: "", // 一共多少页
      pagesizesarr: [5, 10, 20, 50, 100],
      departmentArr: [], // 科室
      titleArr: [], // 职称
      infoObj: {},
    };
  },
  methods: {
    // 搜索
    handleQuery() {
      this.pageIndex = 1;
      if (this.formLabelAlign.practiceName) {
        this.getDataCondition.practiceName = this.formLabelAlign.practiceName;
      } else {
        this.getDataCondition.practiceName = "";
      }
      this.loading = true;
      this.getDatalist();
    },

    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.formLabelAlign = {
        practiceName: "", // 练习名称
        department: "", // 科室
        title: "", // 职称
        examTime: "", // 时间
        createBeginTime: "",
        createEndTime: "",
      };
      this.getDataCondition.practiceName = "";
      this.loading = true;
      this.getDatalist();
    },
    // chang查询
    queryChange() {
      this.loading = true;
      if (this.formLabelAlign.examTime == null) {
        this.formLabelAlign.createBeginTime = "";
        this.formLabelAlign.createEndTime = "";
      }
      this.getDatalist();
    },
    // 获取表格
    async getDatalist() {
      if (this.formLabelAlign.examTime) {
        const time = JSON.parse(JSON.stringify(this.formLabelAlign.examTime));
        this.formLabelAlign.createBeginTime = this.$moment(time[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.formLabelAlign.createEndTime = this.$moment(time[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      this.loading = true;
      let parameter = {
        pageIndex: this.pageIndex - 1, // 页数
        eachPageNum: this.eachPageNum, // 条数
        userID: JSON.parse(loginvuex.state.userlist).userID, // 用户ID
        guid: JSON.parse(loginvuex.state.userlist).guid, // token
        hid: JSON.parse(loginvuex.state.userlist).hid, // 医院ID
        dptId: this.formLabelAlign.department, // 部门ID
        pTitle: this.formLabelAlign.title, // 职称
        startTime: this.formLabelAlign.createBeginTime, // 开始时间
        endTime: this.formLabelAlign.createEndTime, // 结束时间
        searchStr: this.getDataCondition.practiceName, // 名称搜索
      };
      const { data } = await $examApi.practiceSituation(parameter);
      if (data.Status == 200) {
        this.total = data.Data.total;
        this.pagesun = data.Data.pageCount;
        this.getData = data.Data.detail.map((item) => {
          item.rightNum2 =
            ((item.rightNum / item.doNum) * 100).toFixed(2) + "%";
          return item;
        });
        this.infoObj = data.Data;
        this.infoObj.participate = (
          (this.infoObj.joinPeople / this.infoObj.allpeople) *
          100
        ).toFixed(2); // 参与率
        this.infoObj.correct = (
          (this.infoObj.allRightNum / this.infoObj.doneNum) *
          100
        ).toFixed(2); // 正确率

        setTimeout(() => {
          this.loading = false;
        }, 500);
      } else {
        this.$message.error(data.message);
      }
    },
    // 导出
    async exportExcel() {
      let parameter = {
        userID: JSON.parse(loginvuex.state.userlist).userID, // 用户ID
        guid: JSON.parse(loginvuex.state.userlist).guid, // token
        hid: JSON.parse(loginvuex.state.userlist).hid, // 医院ID
        dptId: this.formLabelAlign.department, // 部门ID
        pTitle: this.formLabelAlign.title, // 职称
        startTime: this.formLabelAlign.createBeginTime, // 开始时间
        endTime: this.formLabelAlign.createEndTime, // 结束时间
        searchStr: this.getDataCondition.practiceName, // 名称搜索
      };
      const res = await $examApi.exportPracticeSituation(parameter);
      const blob = new Blob([res.data]);
      let link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", "每日练习情况.xlsx");
      link.click();
      link = null;
    },
    // 表格颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // 分页
    handleSizeChange(val) {
      this.loading = true;
      this.eachPageNum = val;
      this.getDatalist();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.loading = true;
      this.getDatalist();
    },
    // 获取科室数组
    async getStudentlist() {
      let student = {
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        hid: JSON.parse(localStorage.getItem("userlist")).hid,
        pageIndex: "1",
        pageShow: 5,
      };
      const { data } = await getstudentlist.getseekAndCreateExam(student);
      if (data.Status == 200) {
        this.departmentArr = data.Data[1]; // 科室
        this.titleArr = data.Data[3]; // 职称
      } else {
        this.$message.error(data.data);
      }
    },
  },
  computed: {
    // 过滤出对应的科室
    departmentNum() {
      return function () {
        if (this.formLabelAlign.department) {
          let arr = this.departmentArr.filter((item) => {
            return this.formLabelAlign.department == item.DepartmentID;
          });
          return arr[0].DepartmentName;
        } else {
          return "全部";
        }
        return 11;
      };
    },
  },
  created() {
    this.formColumns = exerciseState;
    this.getStudentlist();
    this.getDatalist();
  },
};
</script>

<style lang="scss" scoped>
// 右边整体iframe的css
.mian_view {
  // height: 100%;
  width: 100%;
  min-height: 780px;
  // padding: 24px !important;
  min-width: 1650px;
  background-color: rgb(255, 255, 255);
  padding: 0px 24px;
  h2 {
    // margin-left: 24px;
    padding-top: 24px;
  }
}
// 条件筛选框css
.waitingcom_title {
  height: 81px;
  padding: 24px 24px 16px 0px;
  border-bottom: 1px solid #f8f8f8;
  display: flex;
  ::v-deep .el-form-item__label {
    margin-left: 24px;
    width: 87px !important;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  .el-form {
    display: flex;
    ::v-deep .el-form-item__content {
      margin-left: 115px !important;
    }
    ::v-deep .el-input > .el-input__inner {
      width: 168px;
    }
    ::v-deep .el-form-item {
      &:nth-child(1) {
        .el-form-item__label {
          width: 60px !important;
          margin-left: 0px !important;
        }
        .el-form-item__content {
          margin-left: 60px !important;
        }
      }
    }
  }
  .query_btn {
    margin: 0;
    display: flex;
    .search_left {
      position: relative;
      margin-left: 24px;
      i {
        position: absolute;
        top: 8px;
        left: 10px;
        font-size: 20px;
      }

      ::v-deep .el-input__inner {
        width: 260px;
        height: 40px;
        padding-left: 36px;
        &::-webkit-input-placeholder {
          padding-left: 10px;
        }
        &:focus {
          border: 1px solid #00ae67;
        }
      }
    }
    .el-button {
      width: 88px;
      height: 40px;
      margin-left: 24px;
    }
  }
}
.bubbles_box {
  .bubbles_son {
    display: flex !important;
    p {
      flex: 1;
      width: 80px;
    }
  }
}
.info_view {
  display: flex;
  align-items: center;
  margin-top: 24px;
  p {
    margin-right: 32px;
  }
}
.mian_table {
  background: #ffffffff;
  // height: 700px;
  padding: 24px 0px;
  .add_btn {
    width: 96px;
    height: 40px;
    background: #1890ff;
    opacity: 1;
    border-radius: 4px;
    color: #ffffff;
    margin-bottom: 14px;
  }

  ::v-deep .el-table th:nth-child(1) {
    opacity: 1;
    border-radius: 4px 0px 0px 4px;
  }
  ::v-deep .el-table th:nth-child(13) {
    opacity: 1;
    border-radius: 0px 4px 4px 0px;
  }
  ::v-deep .el-table th > .cell {
    align-items: center !important;
    text-align: center;
  }
  ::v-deep .el-table td > .cell {
    align-items: center !important;
    text-align: center;
  }
  .operation_box {
    ::v-deep .el-button--text {
      font-size: 16px;
      color: #1890ff;
      font-weight: 400;
      &:nth-child(3) {
        color: #ff4747;
      }
    }
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f9f9f9 !important;
}
.bacle_input {
  display: flex;
  padding-right: 40px;
  .examTimeSelect {
    ::v-deep .el-date-editor {
      width: 550px;
    }
    margin-bottom: 30px;
  }
  ::v-deep .el-input {
    width: 550px;
  }
  h5 {
    display: inline-block;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    text-align: left;
    line-height: 40px;
    padding-left: 20px;
    &::before {
      content: "*";
      width: 20px;
      display: inline-block;
      color: #ff0000;
    }
  }
  p {
    margin-left: 10px;
    line-height: 40px;
    text-align: center;
  }
}
// 分页
.foot_box {
  position: relative;
  height: 140px;
  ::v-deep .el-pager li:hover {
    color: #1890ff;
  }
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #1890ff;
        border: none;
      }
    }
  }
}
</style>